import { graphql, Link } from "gatsby"
import React from "react"
import { Card, Col, Container, Image, Row } from "react-bootstrap"
import { PageLayout, PageTitle } from "../components"
import { SEO } from "../utils"

const OffreCard = ({ icon, alt, title, description }) => (
  <div className="col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
    <div className="card">
      <div className="card-block">
        <Image width={64} height={64} src={icon} alt={alt} />
        <h3 className="card-title">{title}</h3>
        <p className="card-text">{description}</p>
      </div>
    </div>
  </div>
)

const ProcessStep = ({ step, title, description, side }) => {
  const isLeft = side === "left"
  return (
    <div className={`row mt-3 ${!isLeft ? "justify-content-end" : ""}`}>
      <div className="col-md-7">
        <div className={`process-box process-${side}`}>
          <div className="row">
            {isLeft && (
              <div className="col-md-3">
                <div className="process-step">
                  <p className="m-0 p-0">Etape {step}</p>
                  <h2 className="m-0 p-0">{String(step).padStart(2, "0")}</h2>
                </div>
              </div>
            )}
            <div className="col-md-9">
              <h5 className="font-weight-bold">{title}</h5>
              <p><small>{description}</small></p>
            </div>
            {!isLeft && (
              <div className="col-md-3">
                <div className="process-step">
                  <p className="m-0 p-0">Etape {step}</p>
                  <h2 className="m-0 p-0">{String(step).padStart(2, "0")}</h2>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

const TestimonialCard = ({ quote, name, flag, role, avatar }) => (
  <div className="col-md-4 mb-4">
    <div className="testimonial-1 rounded h-100 d-flex flex-column">
      <img className="mb-3" src="/images/mentor/citation.png" width="40" alt="citation" />
      <p className="flex-grow-1">{quote}</p>
      <div className="d-flex flex-row align-items-center mt-3">
        <img className="rounded-circle" src={avatar} width="40" height="40" alt={name} style={{ objectFit: "cover" }} />
        <div className="ml-2">
          <h4 className="mb-0"><span className="d-block name-testimony">{name} {flag}</span></h4>
          <span className="place">{role}</span>
        </div>
      </div>
    </div>
  </div>
)

export default ({ data }) => {
  const offres = [
    {
      icon: "/images/mentor/001-lobtention-du-diplome.png",
      alt: "diplome",
      title: "Mentorat Individuel Académique ou Professionnel",
      description: "Sessions personnalisées pour votre évolution académique ou professionnelle.",
    },
    {
      icon: "/images/mentor/002-presentation.png",
      alt: "groupe",
      title: "Mentorat en Groupe",
      description: "Ateliers ou séminaires en groupe sur une technologie ou un sujet spécifique. Sessions interactives avec exercices pratiques et discussions.",
    },
    {
      icon: "/images/mentor/008-livre-ouvert.png",
      alt: "soutenance",
      title: "Session Review Projet de Soutenance",
      description: "Analyse, préparation et feedback constructif pour réussir votre projet de soutenance.",
    },
    {
      icon: "/images/mentor/005-diplome.png",
      alt: "formations",
      title: "Formations sur des Technologies Spécifiques",
      description: "Cours ou sessions de formation sur des langages de programmation, frameworks, outils de développement, etc.",
    },
    {
      icon: "/images/mentor/017-remarques.png",
      alt: "projets",
      title: "Soutien Projets Personnels ou Professionnels",
      description: "Assistance technique et conseils pour les projets de développement d'applications personnels ou professionnels.",
    },
    {
      icon: "/images/mentor/conseil.png",
      alt: "carriere",
      title: "Conseils en Développement de Carrière",
      description: "Accompagnement dans la planification et la progression de votre carrière dans le domaine du génie logiciel et du développement d'applications.",
    },
  ]

  const processSteps = [
    {
      step: 1,
      side: "left",
      title: "Session Découverte",
      description: "Nous commençons par une consultation initiale gratuite pour discuter de vos objectifs, de vos défis et de vos attentes par rapport au mentorat. Cette étape nous permet de mieux nous comprendre et d'établir une base solide pour notre collaboration.",
    },
    {
      step: 2,
      side: "right",
      title: "Évaluation des Besoins",
      description: "Nous procédons à une évaluation approfondie de vos compétences actuelles en génie logiciel et développement d'applications. Cela nous permet de déterminer vos besoins spécifiques et de personnaliser le mentorat en conséquence.",
    },
    {
      step: 3,
      side: "left",
      title: "Planification Personnalisée",
      description: "En fonction de vos objectifs et de notre évaluation, nous élaborons ensemble un plan d'action personnalisé. Ce plan définit les étapes à suivre, les sujets à aborder et les ressources à utiliser pour atteindre vos objectifs de manière efficace.",
    },
    {
      step: 4,
      side: "right",
      title: "Séances de Mentorat",
      description: "Les séances de mentorat sont des sessions individuelles où nous travaillons sur des sujets spécifiques en fonction de vos besoins. Ces sessions peuvent inclure des discussions sur des concepts techniques, des revues de code, des exercices pratiques, etc.",
    },
    {
      step: 5,
      side: "left",
      title: "Feedback et Suivi",
      description: "Après chaque séance, je vous fournis un feedback détaillé sur vos progrès, ainsi que des recommandations pour continuer à avancer. Je reste disponible entre les séances pour répondre à vos questions et vous apporter un soutien continu.",
    },
    {
      step: 6,
      side: "right",
      title: "Ajustements et Réorientations",
      description: "Au fur et à mesure que nous avançons, nous sommes flexibles pour ajuster notre plan d'action en fonction de vos besoins changeants et de vos progrès. Nous pouvons réorienter nos efforts pour nous concentrer sur de nouveaux objectifs ou des domaines difficiles.",
    },
    {
      step: 7,
      side: "left",
      title: "Bilan et Avancement",
      description: "À intervalles réguliers, nous faisons le point sur vos progrès et vos réalisations par rapport à vos objectifs initiaux. Ensemble, nous évaluons ce qui fonctionne bien et ce qui peut être amélioré, afin de maximiser l'efficacité de notre collaboration.",
    },
  ]

  const testimonials = [
    {
      quote: "Lors de mon stage au MINADER, j'ai été confronté à beaucoup de difficultés de part ma recherche d'un thème de soutenance, ma montée en compétences et l'acquisition de softs skills comportementaux et professionnelles. De l'accompagnement personnel au soutien professionnel Regis ATEMENGUE mon maitre de stage été attentif à mes besoins. Aujourd'hui, je peux le dire avec fierté et la plus grande des énergies, c'est le meilleur des mentors 🔥.",
      name: "Asaph AKOA",
      flag: "🇫🇷",
      role: "Data Protection Analyst | Cybersecurity | Developer",
      avatar: "https://ui-avatars.com/api/?name=Asaph+AKOA",
    },
    {
      quote: "J'ai eu l'immense privilège d'être mentoré par Mr Regis Atemengue à partir de mon Master1 à l'université de Yaoundé1. Il a généreusement partagé avec moi ses nombreuses années d'expérience et de connaissances. Ses anecdotes et ses conseils pratiques m'ont été d'une grande valeur. Aussi, son soutien et ses conseils ont été inestimables pour mon développement personnel et professionnel. Il contribue ainsi à la personne que je suis et deviens. Je lui en serai toujours reconnaissant.",
      name: "Dave CHEDJOUN",
      flag: "🇨🇲",
      role: "Étudiant UY-1 | Génie Logiciel",
      avatar: "https://ui-avatars.com/api/?name=Dave+CHEDJOUN",
    },
    {
      quote: "Je suis encore sous le choc de l'efficacité des sessions de mentorat avec Regis. En seulement deux sessions de travail, il a réussi à m'extraire des abysses de l'incompréhension où je me débattais depuis des mois. En quatre heures seulement, j'ai enfin compris ce qui me semblait insaisissable malgré toute ma bonne volonté d'apprendre. C'est tout simplement impressionnant et je suis extrêmement reconnaissant pour son aide précieuse.",
      name: "Cecile Michelle NSTAMA",
      flag: "🇩🇪",
      role: "Étudiante | Big Data",
      avatar: "https://ui-avatars.com/api/?name=Michelle+NSTAMA",
    },
  ]

  return (
    <PageLayout pageName="mentor">
      <SEO title="Mentor" />

      {/* Hero */}
      <Container
        fluid
        className="container-mentor"
        style={{ flexDirection: "column", display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <h1>
          <span className="mentor-text mt-2">
            Guidons votre chemin vers le succès académique et professionnel
          </span>
        </h1>
        <h4 className="slog-mentor">
          Faites équipe avec un mentor expérimenté aujourd'hui
        </h4>
        <p className="d-flex mt-3">
          <a
            href="https://bit.ly/3wnPZpd"
            target="_blank"
            rel="noopener noreferrer"
            className="button button-pulse mr-4 button button-cv"
          >
            Commencer le mentorat
          </a>
        </p>
      </Container>

      {/* Pourquoi un mentor */}
      <Container className="py-5">
        <Row className="mt-3">
          <Col md="6" className="text-left mb-5">
            <h3 className="title-mentor">Pourquoi avoir un mentor académique ou professionnel dans le domaine informatique ?</h3>
            <p className="text-muted h4">Se faire mentoré présente de nombreux avantages :</p>
          </Col>
          <Col md="6" className="text-left">
            {[
              { icon: "👨🏾‍🏫", title: "Guide personnalisé", desc: "Un mentor vous offre un soutien individualisé en fonction de vos besoins, de vos objectifs et de votre parcours professionnel." },
              { icon: "🛠️", title: "Expérience pratique", desc: "Bénéficiez de l'expérience concrète de votre mentor dans votre domaine d'activité. Il a souvent traversé des situations similaires et peut vous fournir des conseils précieux." },
              { icon: "💼", title: "Réseautage et opportunités", desc: "Le mentor peut vous introduire dans son réseau professionnel, vous connectant ainsi à des opportunités de croissance, d'emploi ou de collaboration." },
              { icon: "🚀", title: "Développement de compétences", desc: "Grâce à des conseils ciblés et à des retours d'expérience, vous pouvez développer rapidement et efficacement vos compétences professionnelles." },
              { icon: "🫂", title: "Confiance et motivation", desc: "Un mentor peut vous aider à surmonter les obstacles, à rester concentré sur vos objectifs et à maintenir votre motivation à un niveau élevé." },
            ].map(({ icon, title, desc }) => (
              <div key={title} className="mentor-experience mb-3">
                <h3>{icon} {title} :</h3>
                <p>{desc}</p>
              </div>
            ))}
          </Col>
        </Row>
      </Container>

      <hr className="mentor-section-divider" />

      {/* Rencontrez votre mentor */}
      <Container className="py-5">
        <Row className="mt-3">
          <Col md="6" className="text-left mb-4">
            <Image thumbnail src="/images/mentor/regis-maison-du-cafe.jpeg" alt="Regis Atemengue" />
          </Col>
          <Col md="6" className="text-left">
            <h3 className="title-mentor">Rencontrez votre mentor</h3>
            <p className="text-muted h5">✌🏿 Salut, ici Regis Atemengue !</p>
            <p>Je suis ingénieur logiciel passionné avec plus de 5 ans d'expérience dans l'industrie.</p>
            <p>Mon parcours m'a permis de travailler sur une multitude de projets passionnants, allant du développement d'applications web à la conception de logiciels complexes. Au fil des années, j'ai acquis une expertise approfondie dans divers langages de programmation, frameworks et technologies émergentes.</p>
            <p>Ce qui me distingue, c'est ma passion pour la transmission des connaissances et le mentorat dans le domaine informatique. En parallèle à ma carrière d'ingénieur, j'alloue une part de mon temps à accompagner et à guider ceux qui aspirent à se reconvertir professionnellement ou à approfondir leurs compétences dans ce domaine passionnant.</p>
            <p>J'ai eu le privilège d'accompagner des étudiants venant du Cameroun, d'Allemagne, de France et du Maroc. À travers cette expérience enrichissante, j'ai guidé ces étudiants dans leur apprentissage du génie logiciel et du développement d'applications.</p>
            <p>Que vous soyez un étudiant débutant ou un professionnel chevronné, je suis là pour vous aider à atteindre vos objectifs. Mon engagement envers votre réussite est inébranlable.</p>
          </Col>
        </Row>
      </Container>

      {/* Call to action */}
      <Container fluid>
        <Row>
          <Col className="col-md-12">
            <div className="call-action">
              <div className="container py-4">
                <div className="row align-items-center">
                  <div className="col-xl-12">
                    <h1 className="text-white fw-bold pe-lg-8">
                      Devenez étudiant dès aujourd'hui &amp; Rejoignez une communauté d'apprentissage dynamique
                    </h1>
                    <a
                      href="https://bit.ly/3wnPZpd"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="button button-pulse mr-4 mb-4 button button-cv"
                    >
                      Commencer le mentorat
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      <hr className="mentor-section-divider" />

      {/* Offres de mentorat */}
      <Container className="py-5">
        <Row className="mt-3">
          <section id="mentor-offres" className="w-100">
            <div className="container-fluid">
              <h2 className="mb-2 title-mentor text-left">Découvrez les offres de mentorat</h2>
              <p className="text-muted h4 text-left">Offres adaptées à vos besoins avec accompagnement personnalisé vers l'excellence technique.</p>
              <div className="row mt-5">
                {offres.map(offre => (
                  <OffreCard key={offre.title} {...offre} />
                ))}
              </div>
            </div>
          </section>
        </Row>
      </Container>

      <hr className="mentor-section-divider" />

      {/* Processus de mentorat */}
      <Container className="py-5">
        <Row className="mt-3">
          <section id="mentor-processus" className="w-100">
            <div className="container-fluid">
              <h2 className="mb-2 text-left title-mentor">Processus de Mentorat</h2>
              <p className="text-left text-muted h5">Découvrez notre processus de mentorat sur mesure.</p>
            </div>
          </section>
        </Row>
        <section className="our-blog p-0 m-0 bg-silver">
          <div className="container work-process pb-5 pt-5">
            {processSteps.map(step => (
              <ProcessStep key={step.step} {...step} />
            ))}
          </div>
        </section>
      </Container>

      <hr className="mentor-section-divider" />

      {/* Témoignages */}
      <Container className="py-5">
        <section id="mentor-temoignages">
          <div className="container-fluid">
            <h2 className="mb-2 title-mentor h1 text-left">Témoignages</h2>
            <p className="text-muted h5 text-left">Explorez les témoignages inspirants de mes étudiants.</p>
          </div>
          <div className="container mt-5">
            <div className="row">
              {testimonials.map(t => (
                <TestimonialCard key={t.name} {...t} />
              ))}
            </div>
          </div>
        </section>
      </Container>
    </PageLayout>
  )
}
